/*
 * custom.js — Norrsken custom front-end scripts.
 * Moved out of the inline <script> blocks in layout/theme.liquid (Phase 5)
 * so they load once, cached and deferred, instead of ~180 lines of inline JS
 * on every page. Loaded via: {{ 'custom.js' | asset_url }} with defer.
 */

/* 1) Top-level menu label navigation ------------------------------------ */
document.addEventListener('DOMContentLoaded', function () {
  // Destination URL for each top-level menu label
  var menuUrls = {
    windows: '/pages/windows-range',
    doors: '/pages/doors-range',
    gallery: '/blogs/gallery',
    resources: '/pages/resources',
    about: '/pages/about',
    visit: '/blogs/tradeshows',
    contact: '/pages/contact'
  };

  document.querySelectorAll('.header__menu-item span').forEach(function (span) {
    // Skip if this span is inside the caret icon
    if (span.closest('.svg-wrapper')) return;

    span.style.cursor = 'pointer';

    span.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var menuText = this.textContent.toLowerCase().trim();
      var url = menuUrls[menuText];
      if (url) window.location.href = url;
    });
  });
});

/* 2) Mega menu hover (mouse / trackpad only) ---------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  // Only add hover behaviour for devices that actually hover (mouse/trackpad).
  // Touch devices fall through to Dawn's native click/tap toggle on <summary>.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.mega-menu').forEach(function (menu) {
    menu.addEventListener('mouseenter', function () { menu.setAttribute('open', ''); });
    menu.addEventListener('mouseleave', function () { menu.removeAttribute('open'); });
  });
});

/* 3) FAQ accordion ------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(function (button) {
    button.addEventListener('click', function () { toggleFAQ(this); });
  });
});

// Kept global so any inline onclick="toggleFAQ(this)" in the FAQ section still works.
function toggleFAQ(button) {
  var answer = button.nextElementSibling;
  var arrow = button.querySelector('.faq-arrow');

  if (answer.classList.contains('expanded')) {
    answer.classList.remove('expanded');
    if (arrow) arrow.classList.remove('expanded');
  } else {
    // Close all others first
    document.querySelectorAll('.faq-answer.expanded').forEach(function (item) {
      item.classList.remove('expanded');
    });
    document.querySelectorAll('.faq-arrow.expanded').forEach(function (a) {
      a.classList.remove('expanded');
    });

    answer.classList.add('expanded');
    if (arrow) arrow.classList.add('expanded');
  }
}

/* 4) Click-to-copy email (mailto links) --------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="mailto:"]').forEach(function (mailtoLink) {
    // Avoid processing the same link twice
    if (mailtoLink.dataset.copyEnabled) return;
    mailtoLink.dataset.copyEnabled = 'true';

    var email = mailtoLink.href.replace('mailto:', '').split('?')[0];

    mailtoLink.style.cursor = 'pointer';
    mailtoLink.title = 'Click to copy email';

    mailtoLink.addEventListener('click', function (e) {
      e.preventDefault(); // Stop mailto from opening

      var done = function (success) { showCopiedTooltip(mailtoLink, success); };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(email).then(function () { done(true); }, function () { done(false); });
      } else {
        // Fallback for older browsers or HTTP
        var textarea = document.createElement('textarea');
        textarea.value = email;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
        document.body.removeChild(textarea);
        done(ok);
      }
    });
  });

  function showCopiedTooltip(element, success) {
    var existing = element.querySelector('.copy-tooltip');
    if (existing) existing.remove();

    var tooltip = document.createElement('span');
    tooltip.className = 'copy-tooltip';
    tooltip.textContent = success ? 'Copied!' : 'Failed to copy';
    tooltip.style.cssText =
      'position:absolute;background:' + (success ? '#333' : '#c00') + ';color:#fff;' +
      'padding:4px 10px;border-radius:4px;font-size:12px;white-space:nowrap;' +
      'transform:translateY(-100%);margin-top:-6px;left:0;opacity:0;' +
      'transition:opacity 0.2s;pointer-events:none;';

    if (getComputedStyle(element).position === 'static') {
      element.style.position = 'relative';
    }

    element.appendChild(tooltip);
    requestAnimationFrame(function () { tooltip.style.opacity = '1'; });

    setTimeout(function () {
      tooltip.style.opacity = '0';
      setTimeout(function () { tooltip.remove(); }, 200);
    }, 1200);
  }
});